import React from 'react';
import appointmentSelectors from 'features/appointment/services/selectors';
import { IStaffItemData } from 'services/shop/types/staff';
import { useAppDispatch } from 'store/hooks';
import appointmentActions from 'features/appointment/services/actions';
import SelectStaff from 'components/SelectStaff';
import { CALENDAR_VIEW_TYPE } from 'features/appointment/services/constants';

const SortingStaffSelected = () => {
  const staffFilter = appointmentSelectors.staffFilter();
  const dispatch = useAppDispatch();
  const handleChangeStaffFilter = (staff: IStaffItemData) => {
    dispatch(appointmentActions.setStaffFilter(staff));
  };
  const viewType = appointmentSelectors.getViewType();

  if (viewType === CALENDAR_VIEW_TYPE.DAY_VIEW) {
    return (
      <div style={{ width: '100%' }}>
        <SelectStaff value={staffFilter || undefined} onChange={handleChangeStaffFilter} />
      </div>
    );
  }
  return <div></div>;
};

export default SortingStaffSelected;
